/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_SendInvoiceEmailRequest = {
    lang?: billing_SendInvoiceEmailRequest.lang;
    payer_id?: string;
};
export namespace billing_SendInvoiceEmailRequest {
    export enum lang {
        DE = 'de',
        EN = 'en',
        FR = 'fr',
        IT = 'it',
        ES = 'es',
        PT = 'pt',
    }
}

